/**
 * ReviewStatusPill — the one CG-review status → pill mapping for the Sales
 * calendar (rows, review queue, detail modal). Approved is the everyday
 * state, so it renders quiet; Needs review, Declined and Withdrawn keep their
 * filled pills so they stand out in a list of approved plans.
 */

import React from 'react';
import { StatusPill } from '../../ui';
import { CalendarEntryStatus, ENTRY_STATUS_LABELS } from './types';
import { ENTRY_STATUS_VARIANT } from './shared';

interface ReviewStatusPillProps {
  status: CalendarEntryStatus;
  size?: 'sm' | 'md';
}

const ReviewStatusPill: React.FC<ReviewStatusPillProps> = ({ status, size = 'sm' }) => (
  <StatusPill
    variant={ENTRY_STATUS_VARIANT[status]}
    size={size}
    appearance={status === 'approved' ? 'quiet' : 'filled'}
  >
    {ENTRY_STATUS_LABELS[status]}
  </StatusPill>
);

export default ReviewStatusPill;
